module.exports = __webpack_public_path__ + "static/media/D_7.b18bcea3.png";